import { AutocompleteInput, DeleteButton, SaveButton } from "@/components/admin";
import { Card } from "@/components/ui/card";
import { Briefcase } from "lucide-react";
import {
  Edit,
  NumberInput,
  ReferenceInput,
  SimpleForm,
  TextInput,
} from "../common";

const DesignationEditToolbar = () => (
  <div className="form-toolbar-premium">
    <DeleteButton className="btn-delete-action" />
    <SaveButton className="btn-green-action" label="Update Designation" />
  </div>
);

export const DesignationEdit = () => (
  <Edit title="Edit Designation" actions={false}>
    <Card className="form-container">
      <div className="form-header-premium">
        <Briefcase className="w-6 h-6 text-emerald-600" />
        <h2 className="text-2xl font-bold text-slate-900">Edit Designation Details</h2>
      </div>
      <SimpleForm toolbar={<DesignationEditToolbar />}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <TextInput source="title" label="Designation Title" />
          <NumberInput source="level" label="Hierarchical Level" />
          <ReferenceInput source="department_id" reference="hr_departments">
            <AutocompleteInput label="Department" optionText="name" />
          </ReferenceInput>
        </div>
      </SimpleForm>
    </Card>
  </Edit>
);

